export function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-50" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="h-8 w-8 rounded-lg bg-blue-700 text-white flex items-center justify-center font-bold text-[10px] tracking-tight">DHD</div>
            <span className="font-semibold text-slate-900">Domain Host Directory</span>
          </div>
          <p className="text-sm text-slate-600 max-w-sm">
            The nation's trust-forward directory for premium businesses and verified professionals.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li><a href="/directory" className="hover:text-blue-700">Directory</a></li>
            <li><a href="/directory?type=professional" className="hover:text-blue-700">Professionals</a></li>
            <li><a href="/directory?featured=1" className="hover:text-blue-700">Featured listings</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-3">For Business</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li><a href="/register" className="hover:text-blue-700">Claim your listing</a></li>
            <li><a href="/dashboard" className="hover:text-blue-700">Owner dashboard</a></li>
            <li><a href="/register" className="hover:text-blue-700">Get verified</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Domain Host Directory (DHD). Nationwide directory for premium businesses.
      </div>
    </footer>
  );
}
